import React from "react";

/**
 * Centered, max-width, padded page wrapper. Replaces the inline
 * `max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 ...` wrappers repeated per page.
 */
function PageContainer({ className = "", children }) {
  return (
    <div
      className={`max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 sm:my-6 lg:my-10 ${className}`}
    >
      {children}
    </div>
  );
}

export default PageContainer;
